const API_URL =
  process.env.REACT_APP_URL || "https://a3routeinfo-dev.avinet.no/api";
const WEBSITE_URL = "https://a3routeinfo-dev.avinet.no";

export interface ApiConfig {
  url: string;
  webUrl: string;
  timeout: number;
}

export const DEFAULT_API_CONFIG: ApiConfig = {
  url: API_URL,
  webUrl: WEBSITE_URL,
  timeout: 8000,
};
